import { Controller } from "@hotwired/stimulus"
import { track } from '../../heap'

export default class extends Controller {
  static values = {
    data: { type: Object, default: {} },
    eventName: String,
    id: String,
  }

  connect() {
    track({
      data: this.dataValue,
      eventName: this.eventNameValue,
      id: this.idValue,
    })
  }
}
